/* eslint-disable */
import { phoneSources } from '@ringcentral-integration/commons/enums/phoneSources';
export default {
  [phoneSources.account]: 'Cuenta',
  [phoneSources.contact]: 'Contacto',
  [phoneSources.rcContact]: '{brand}',
  [phoneSources.lead]: 'Cliente potencial',
  [phoneSources.opportunity]: 'Oportunidad',
  [phoneSources.systemUser]: 'Usuario del sistema',
};

// @key: @#@"[phoneSources.account]"@#@ @source: @#@"Account"@#@
// @key: @#@"[phoneSources.contact]"@#@ @source: @#@"Contact"@#@
// @key: @#@"[phoneSources.rcContact]"@#@ @source: @#@"{brand}"@#@
// @key: @#@"[phoneSources.lead]"@#@ @source: @#@"Lead"@#@
// @key: @#@"[phoneSources.opportunity]"@#@ @source: @#@"Opportunity"@#@
// @key: @#@"[phoneSources.systemUser]"@#@ @source: @#@"System User"@#@
